import styled from "styled-components";
import { theme } from "../theme";

export const StyledTag = styled.span`
	background: ${theme.color.blue0};
	border: 1px solid ${theme.color.blue1};
	border-radius: 1.6rem;
	padding: 0.4rem 0.9rem;
	display: inline-block;
	font-size: 0.75rem;
	font-weight: 500;
	font-family: ${theme.font.secondary};
	color: ${theme.color.blue3};
	text-transform: uppercase;
	letter-spacing: 0.025em;
	white-space: normal;
	word-break: break-word;
	hyphens: auto;
	line-height: 1.3;
	max-width: 100%;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
	transition: all 0.2s ease;

	&:hover {
		background: ${theme.color.blue1};
		transform: translateY(-1px);
		box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
	}
`;
